module.exports = __webpack_public_path__ + "img/Bilfinger_2012-2.1eee5d00.png";